import React, { Fragment, useState } from 'react'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import { Checkbox } from "Components";
import Typography from '@mui/material/Typography';
import cx from 'classnames';
import moment from 'moment';
import { useSelector } from "react-redux";
import { useIntl } from 'react-intl';
import { GetFormatForMoment } from 'Core/data/Helpers';
import { Button } from 'Components/uiControls';

import './style.scss'

const RouteList = (props) => {
    const { data, id, provided, count, item, checkedItem,openMap } = props
    const user = useSelector(state => state.securityRedux.user);
    const { locale } = useIntl()

    const [checked, setChecked] = useState(false);
    if (data && data.length == 0) {
        return (<div></div>)
    }


    const lastConnected = item?.date !== "0000-00-00 00:00:00" 
        ? moment(item.date).locale(locale).format(GetFormatForMoment(user.dateformat)) 
        : ''

    return (
        <ListItem
            key={id}
            className={cx('BackGrounItems',
                count % 2 == 0 ? 'BackGrounItemsSecundary' : '')}
            alignItems="flex-start"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
                ...provided.draggableProps.style,
                transition: `all 100ms ease-out`,
                padding: 0,
                resize: 'none'
            }}
        >
            <ListItemAvatar style={{ paddingLeft: 20 }}>
                <Checkbox
                    id={'select-all-item-list'}
                    value={checked}
                    onChange={(check) => {
                        setChecked(check)
                        checkedItem(check, item)
                    }}
                    size="small"
                />
            </ListItemAvatar>
            <ListItemText
                disableTypography
                primary={<Typography  style={{ fontWeight: 'bold' }}>{item?.name}
                    <Button
                        type="icon"
                        icon="public"
                        placement="bottom"
                        onClick={() => {
                            openMap(item)
                        }}
                    />
                </Typography>}
                secondary={
                    <Fragment>
                        <Fragment>
                            <Typography
                                component="span"
                                variant="body2"
                                className='ListItemText-inline'
                                color="textPrimary"
                            >
                                {item?.description}
                            </Typography>
                            <br></br>
                            <Typography variant="body2" color="textSecondary" style={{ fontSize: 12 }}>
                                {lastConnected}
                            </Typography>
                        </Fragment>
                    </Fragment>
                }

            />
        </ListItem>

    );
}

export default RouteList;